import { headerAuth } from "../standardAuthPatterns";
import { productVariant } from "../types";
import { exactUrlToRegex } from "../urlPatternConversion";

export const fortifySoftwareSecurityCenter = productVariant({
  identifier: "fortifySoftwareSecurityCenter",
  authLabel: "Software Security Center",
  protocol: "http",
  defaultUrlPattern: ({ baseUrl }) =>
    exactUrlToRegex(baseUrl || "https://ssc.example.com/ssc/api/v1"),
  auth: headerAuth([
    {
      name: "Authorization",
      value: { from: "template", template: "FortifyToken {secrets.apiToken}" },
    },
  ]),
  steps: [
    {
      title: "Set up Fortify Software Security Center",
      items: [
        {
          kind: "markdown",
          content:
            "Ask your SSC administrator to issue an API token for an account with access to read applications and project versions. Enter its encoded token value below and replace it before its expiration date. See the [Fortify token examples](https://fortify.github.io/ssc-js-sandbox-docs/) and [SSC API reference](https://github.com/fortify/ssc-restapi-client).",
        },
      ],
    },
    {
      title: "Enter connection details",
      items: [
        {
          kind: "baseUrl",
          label: "API base URL",
          required: true,
          placeholder: "https://ssc.example.com/ssc/api/v1",
          target: {
            kind: "configuration",
            field: "baseUrl",
          },
          helperText:
            "Replace the example hostname with the HTTPS hostname and deployment context of the SSC server. The documented API path is /api/v1; SSC deployments commonly expose it under the server context path, such as /ssc/api/v1.",
        },
        {
          kind: "input",
          label: "Encoded SSC API token",
          required: true,
          target: {
            kind: "secrets",
            field: "apiToken",
          },
          helperText:
            "Paste the encoded API token value used after FortifyToken in the Authorization header, without the prefix.",
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ baseUrl }) => ({
      url:
        (baseUrl || "https://ssc.example.com/ssc/api/v1")
          .trim()
          .replace(/\/+$/, "") + "/projects?limit=1",
      ...{ method: "GET" },
    }),
  },
});
